<template>
  <div class="i-container">
    <div
      class="comment-response-container"
      :class="{ active: commentResponse }"
    >
      <div v-if="commentResponse" class="comment-response-username">
        {{ $t("comments.placeholder.responding_to") + " " + commentResponse.user.username }}
      </div>
      <div 
        class="comment-response-close"
        @click="cancelReply"
        >
        <i class="fas fa-times"></i>
      </div>
    </div>

    <div class="icons-container">
      <div v-for="icon in icons" class="icon-box">
        <div class="icon-text" @click="chooseIcon">{{ icon }}</div>
      </div>
    </div>

    <div class="comment-container">
      <div class="profile-pic-container">
        <UserIcon :imageUrl="profile_pic" :logged="true" />
      </div>
      <div class="comment-input">
        <input
          class="comment-textarea"
          ref="textarea"
          :value="textInput"
          @change="textInput = $event.target.value"
          :placeholder="$t('comments.placeholder.write_comment')"
        />
      </div>
      <div class="button">
        <div class="button-text" @click="sendComment">{{ $t("comments.placeholder.publish") }}</div>
        <!-- <i class="icon" @click="sendComment" aria-hidden="true"></i> -->
      </div>
    </div>
  </div>
</template>
<script>
import resources from "../../resources";

import "../../../public/js/lib/FontAwesomeKit.js"; // <--- importing FontAwesome icons
import UserIcon from "./UserIcon.vue";

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // icons: ["❤️", "🙌", "🔥", "👏", "😢", "😍", "😯", "😂"],
      icons: ["👍", "🔥", "❤️", "🥰", "😮", "😈", "💋", "💦"],
      textInput: "",
      profile_pic: null,
      commentResponse: null,
    };
  },
  methods: {
    chooseIcon(e) {
      const icon = e.target.innerText;
      this.textInput += icon;
    },
    sendComment() {
      const message = this.textInput;
      
      let commentId = null;
      if (this.commentResponse) {
        commentId = this.commentResponse.id;
      }
      
      this.textInput = "";
      this.commentResponse = null;

      resources.comments
        .sendComment(this.post.post_id, message, commentId)
        .then((response) => {
          const data = response.data;

          if (data.success) {
            this.$emit("sendMessage", data.data);
          }
        })
        .catch((err) => {
          if (err.status === 429) {
            this.$toast.error(this.$t("comments.messages.too_many_comments"), {
              duration: 3000,
              position: "top-right",
            });
          }
        });
    },
    replyTo(comment) {
      this.textInput = `@${comment.user.username} `;
      this.$refs.textarea.focus();

      this.commentResponse = comment;
    },
    cancelReply() {
      this.commentResponse = null;
      this.textInput = "";
      this.$emit("cancelReply");
    },
  },
  components: { UserIcon },
  mounted() {
    this.$refs.textarea.focus();

    const user = this.$auth.user();
    if (user) this.profile_pic = user.profile_pic;

    // if (this.$auth.check()) {
      // const profile_pic = this.$auth.user().profile_pic;
      // this.profile_pic = resources.user.getProfilePicURL(profile_pic);
    // }
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";

.i-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
}

.comment-response-container {
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  width: 100%;

  transition: all 0.25s;
  transform: translateY(100%);
  opacity: 0;
  height: 0;
  pointer-events: none;

  position: relative;
  z-index: 9;
  background-color: var(--background_01);

  &.active {
    transform: translateY(0);
    opacity: 1;
    height: unset;
    padding-block: 0.75em;
    pointer-events: all;
  }

  >.comment-response-username {
    margin: 0;
    margin-left: 1em;
    font-size: 0.9em;

    &::selection {
      background: none;
    }
  }

  >.comment-response-close {
    display: flex;

    width: 1.25em;
    height: 1.25em;
    margin-inline: auto 1em;
    margin-block: auto;
    
    cursor: pointer;
    
    >i {
      font-size: 1em;
      margin: auto;
    }
  }
}

.comment-container {
  display: flex;
  justify-content: center;
  width: 100%;

  margin: 0;
  padding-inline: 0.75em;
}

.icons-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  margin: 0;
  padding: 0.5em 0;

  position: relative;
  z-index: 99;
  background-color: inherit;

  .icon-box {
    display: flex;
    height: 3em;
    width: 2em;
    cursor: pointer;
    flex-grow: 1;

    > .icon-text {
      font-size: 1.75em;
      transition: font-size 0.25s;
      text-align: center;
      margin: auto;

      &:hover {
        font-size: 2.25em;
      }

      &::selection {
        background: none;
      }
    }
  }
}

.button {
  display: flex;
  position: relative;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  min-width: fit-content;

  margin-left: 0.5em;

  &::selection,
  &:active {
    background: none;
  }

  > .button-text {
    width: fit-content;
    height: min-content;
    margin-top: auto;

    font-weight: 600;
    color: var(--pallete_main_color);
  }
}

.icon {
  font-size: 25px;
  vertical-align: bottom;

  margin: auto;

  // Image
  width: 28px;
  height: 28px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/img/btn/paper-plane.png");
}

.profile-pic-container {
  display: flex;
  margin-right: 0.5em;
  margin-block: auto;
}

.comment-input {
  display: flex;
  width: 100%;
  overflow: hidden;

  > .comment-textarea {
    width: 100%;
    height: min-content;
    margin-block: auto;
    resize: none;
    outline: none;

    text-wrap: nowrap;
    // overflow-y: scroll;

    // border-radius: 5px;
    // border: 1px solid var(--background_01);
    // background-color: var(--pallete_over_main_text_color);
    font: inherit;
    color: inherit;
    border: none;
    background: inherit;

    caret-shape: bar;
    caret-color: var(--pallete_main_color);
  }

  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
